export default {
    baseUrl: {
        // 开发环境
        // dev: 'https://api.twzc.chima.vip/',
        dev: 'https://saas.twzc.gdtwzc.com/',

        // 生产环境
        prod: 'https://oaapi.twzc.gdtwzc.com'
    }
}